import React from 'react';
import { Card, Table } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ADMIN_COMMON_ACTIONS, CONSULTANT_COMMON_ACTIONS } from '@rd-web-markets/market/dist/constants';
const CommonActions = _ref => {
  let {
    accountType
  } = _ref;
  const {
    t
  } = useTranslation();
  const location = useLocation();
  const getActions = actionsList => actionsList.map(action => {
    return {
      text: t(action.text),
      link: `${location.pathname}/${action.link}`
    };
  });
  const actions = accountType === 'admin' ? getActions(ADMIN_COMMON_ACTIONS) : getActions(CONSULTANT_COMMON_ACTIONS);
  return /*#__PURE__*/React.createElement(Card, {
    className: "px-4 py-3 h-100"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "font-weight-bold"
  }, t('common_actions')), /*#__PURE__*/React.createElement(Table, {
    className: "table borderless"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null))), /*#__PURE__*/React.createElement("tbody", null, actions.map((action, index) => {
    return /*#__PURE__*/React.createElement("tr", {
      key: index
    }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Link, {
      to: action.link
    }, "+ ", action.text)));
  }))));
};
export default CommonActions;